import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HeroHeader from '../components/HeroHeader';
import BookingBg from '../assets/images/header-backgrounds/background2.png';
import { Section } from '../components/styled/CommonStyles';
import { Helmet } from 'react-helmet-async';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const { currentTheme } = useTheme();

  return (
    <>
      <Helmet>
        <script>
          {`
            gtag('event', 'complete_checkout', {
              // <event_parameters>
            });
          `}
        </script>
      </Helmet>
      <HeroHeader 
        title="Thank You"
        backgroundImage={BookingBg}
      />
      <Section theme={currentTheme}>
        <Container maxWidth="md">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 4
            }}
          >
            <CheckCircleOutlineIcon 
              sx={{ 
                fontSize: 100, 
                color: 'success.main',
                animation: 'scaleIn 0.5s ease-out'
              }} 
            />
            
            <Typography variant="h4" component="h1" gutterBottom>
              Booking Confirmed!
            </Typography>
            
            <Typography variant="h6" color="text.secondary" paragraph>
              Thank you for choosing Hawkins Carpet Cleaning. We've received your booking and will be in touch shortly to confirm the details.
            </Typography>
{/*           
            <Typography variant="body1" color="text.secondary" paragraph>
              A confirmation email has been sent to your email address with all the booking details.
            </Typography> */}

            <Box sx={{ mt: 4, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/')}
              >
                Return to Home
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<PhoneIcon />}
                onClick={() => window.location.href = "tel:2703150389"}
              >
                Call Us: 270-315-0389
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<EmailIcon />}
                onClick={() => window.location.href = "mailto:hawkinscarpet@gmail.com"}
              >
                Email Us
              </Button>
            </Box>
          </Box>
        </Container>
      </Section>
    </>
  );
};

export default ThankYouPage; 